import { createContext } from "react";
import { IProfile } from "../util/GraphService";

export const GraphProfileContext = createContext<IProfile>({ photo: undefined, displayName: 'unknown', email: 'unknown' });